module.exports = __webpack_public_path__ + "static/media/article-blog-img2.2093c7cf.png";